
import React from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import useTranslation from '@/Hooks/UseTranslation'
import { useProject } from '@/Hooks/UseProject'

import TeamsActions from '@/Redux/Actions/TeamsActions'

import './PendingInvite.scss'

const PendingInvite = ({ invite }: any) => {

    const { t } = useTranslation()

    const history = useHistory()

    const dispatch = useDispatch()

    const { loadProject } = useProject()

    const handleAccept = () => {

      const project_id = invite.project._id;

      dispatch(TeamsActions.acceptInviteAction(
          invite,
          project_id
      ));

      loadProject()
    }

    const handleReject = () => {

      const project_id = invite.project._id;

      dispatch(TeamsActions.rejectInviteAction(
          invite,
          project_id
      ));

      history.push('/')
    }

    return (
      <Row className="justify-content-md-center">
        <Col md={5}>
          <Card className='pending-invite-card'>
            <Card.Header>
              <Card.Title as="h5">
                {t('PROJECT_INVITE:Title')}
              </Card.Title>
            </Card.Header>
            <div className="card-body">
              <p className="mb-3">
                <span style={{ fontWeight: 700 }}>
                  {invite.userFrom.name}
                </span>{' '}
                {t('PROJECT_INVITE:BodyOne')}{' '}
                <span style={{ fontWeight: 700 }}>
                  {invite.team.name}
                </span>{' '}
                {t('PROJECT_INVITE:BodyTwo')}{' '}
              </p>
            </div>
            <Card.Footer className="text-right">
              <Button variant="primary" onClick={() => handleAccept()}>
                {t('PROJECT_INVITE:AcceptButton')}
              </Button>{' '}
              <Button variant="secondary" onClick={() => handleReject()}>
                {t('PROJECT_INVITE:RejectButton')}
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    )
}

export default PendingInvite
